/**
 *
 * WidgetInitHeaderDetails
 *
 */

import React from "react"
// import PropTypes from 'prop-types';
import { Divider } from "antd"
import { get, pick } from "lodash"
import WidgetDates from "../WidgetDates"
import WidgetResumen from "../WidgetResumen"
import WidgetResponseRate from "../WidgetResponseRate"
import WidgetDetailsResponse from "../WidgetDetailsResponse"
import BoxMeasurementResponse from "../BoxMeasurementResponse"

/* eslint-disable react/prefer-stateless-function */
class WidgetInitHeaderDetails extends React.Component {

  componentDidMount() {

    const {
      match: { params },
    } = this.props

    this.props.getDetailCounts(params.id)
  }
  render() {
    const view_climate =
      get(this.props.measureStatus, "measure.id_survey_type", 0) === 1

    return (
      <div
        className="measurement-details-views"
        style={{
          gridTemplateColumns:
            get(this.props.measureStatus, "id_measure_status", 0) !== 5
              ? "1fr 16px auto 1fr"
              : "280px 280px 1fr 360px",
        }}>
          <>
            {get(this.props.measureStatus, "id_measure_status", 0) !== 5 ? (
            <React.Fragment>
              <WidgetDates
                {...pick(this.props, [
                  "isLoadingDatesProgramming",
                  "datesProgramming",
                  "isLoadingDates",
                  "editDatesWatcher",
                  "progDates",
                  "getDatesWatcher",
                  "showAlert",
                  "showAlertResendSurveyToNews",
                ])}
                idSurvey={this.props.match.params.id}
                measureStatus={get(
                  this.props.measureStatus,
                  "id_measure_status",
                  ""
                )}
              />
              <Divider type="vertical" style={{ height: "12.4rem" }} />
            </React.Fragment>
          ) : (
            <WidgetResumen
              className="WidgetResumenComponent boxShadow"
              title={
                <div>
                  Resultado de{" "}
                  <b>
                    {get(
                      this.props.measureStatus,
                      "metric_total_label",
                      ""
                    )}
                  </b>
                </div>
              }
              hideMeasurePrev
              isLoading={this.props.isLoadingStatus}
              calculationType={get(this.props.measureInfo, "id_survey_calculation_type", {})}
              data={get(this.props.measureStatus, "measure_climate", {})}
            />
          )}
          <WidgetResponseRate
            {...this.props}
            isLoading={this.props.isLoadingMeasureRate}
            async={true}
            data={get(this.props, "measureRate", {})}
          />
          <WidgetDetailsResponse
            isLoading={this.props.isLoadingDetailCounts}
            responseTime={get(this.props, "detailCounts", {})}
            
          />
          {
          get(this.props.measureStatus, "id_measure_status", 0) ===
            5 && (
            <BoxMeasurementResponse
              data={get(this.props, "dimensionRanks.data", {})}
            />
          )}
          </>
      </div>
    )
  }
}

WidgetInitHeaderDetails.propTypes = {}

export default WidgetInitHeaderDetails
